module.exports = __webpack_public_path__ + "static/media/question.90be47e9.svg";